export const searchMap = {
  SEARCH_MAP_CLOSED: 'Search.MapClosed',
  SEARCH_MAP_REFRESH: 'Search.MapRefresh'
}
